import { Star } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";

const ITEMS = [
  {
    q: "They talked me out of the project I walked in asking for, and showed me why the next sector was better value. That honesty closed it for me.",
    n: "Ankit & Shweta",
    d: "3BHK · Siddharth Vihar",
  },
  {
    q: "I was quoted three different prices by three channel partners. BRICKSPACE put everything on one sheet and negotiated ₹4.2L off.",
    n: "Rajeev Tyagi",
    d: "Villa · Aditya World City",
  },
  {
    q: "Two site visits, one Sunday, pickup from Vaishali metro. My parents were comfortable the whole day.",
    n: "Dr. Meera Nanda",
    d: "Plot · Wave City",
  },
  {
    q: "The paperwork check caught a pending approval issue. We moved to a cleaner project and slept better.",
    n: "Suresh Bansal",
    d: "Investor · NH-24",
  },
];

const Card = ({ item }) => (
  <figure className="card-soft w-[320px] shrink-0 p-6 sm:w-[380px]">
    <div className="flex gap-0.5">
      {[0, 1, 2, 3, 4].map((i) => (
        <Star key={i} className="h-3.5 w-3.5 fill-brand text-brand" />
      ))}
    </div>
    <blockquote className="mt-4 text-sm leading-relaxed text-ink2">“{item.q}”</blockquote>
    <figcaption className="mt-5 border-t border-line pt-4">
      <div className="text-sm font-bold text-ink">{item.n}</div>
      <div className="mt-0.5 text-xs text-muted2">{item.d}</div>
    </figcaption>
  </figure>
);

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="overflow-hidden bg-cloud py-20 lg:py-24">
    <div className="mx-auto max-w-[1280px] px-5 lg:px-8">
      <Reveal>
        <SectionLabel index="04">Client outcomes</SectionLabel>
        <h2 className="mt-5 max-w-xl font-display text-3xl font-extrabold leading-tight text-ink sm:text-4xl">
          480+ families have already moved in with our advice
        </h2>
      </Reveal>
    </div>
    <div className="mt-11 flex w-full overflow-hidden">
      <div className="marquee-track flex gap-5 pl-5 lg:pl-8">
        {[...ITEMS, ...ITEMS].map((item, i) => (
          <Card key={i} item={item} />
        ))}
      </div>
    </div>
  </section>
);
